import { Badge } from "@vlab-corporation/design-system";

interface MemberTypeBadgeProps {
  member?: { id?: string } | null;
  classDate?: string;
  instructorId?: string;
  /** 회원×강사 재등록 맵. key: "memberId_instructorId", value: reRegistrationDate */
  reRegistrations?: Map<string, string>;
}

/**
 * 회원 유형 배지 컴포넌트.
 *
 * N:N 재등록 관계 기반으로 회원 유형을 결정한다:
 * - member가 없거나 null → 동기화 실패 경고 아이콘
 * - reRegistrations에서 해당 (memberId, instructorId)의 reRegistrationDate 조회
 * - classDate >= reRegistrationDate → "재등록" 배지
 * - 그 외 → "신규" 배지
 */
export function MemberTypeBadge({
  member,
  classDate,
  instructorId,
  reRegistrations,
}: MemberTypeBadgeProps) {
  if (!member) {
    return (
      <span className="group relative inline-flex cursor-help text-amber-500">
        ⚠
        <span className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
          회원 정보가 동기화되지 않았습니다.
        </span>
      </span>
    );
  }

  if (reRegistrations && instructorId) {
    const reRegDate = reRegistrations.get(`${member.id}_${instructorId}`);
    if (reRegDate && classDate && classDate >= reRegDate) {
      return <Badge variant="success">재등록</Badge>;
    }
  }

  return <Badge variant="info">신규</Badge>;
}
